import Controller from '@ember/controller';
import { POSTING_CREATE__QUERY_PARAMS } from 'sh-www/constants/routes/posting-create';

export default class PostingCreateController extends Controller {
  /**
   * @inheritDoc
   */
  queryParams = [
    POSTING_CREATE__QUERY_PARAMS.CLONE_ID,
    POSTING_CREATE__QUERY_PARAMS.SERVICE_IDS,
    POSTING_CREATE__QUERY_PARAMS.CLASSIFICATION_IDS,
    POSTING_CREATE__QUERY_PARAMS.LOCATION_ID,
    POSTING_CREATE__QUERY_PARAMS.MAX_RATE,
    POSTING_CREATE__QUERY_PARAMS.RATE_TYPE,
  ];

  /**
   * @type {String}   Assignment id we want to clone.
   */
  [POSTING_CREATE__QUERY_PARAMS.CLONE_ID] = null;

  /**
   * @type {String} Service IDs to fill by default
   */
  [POSTING_CREATE__QUERY_PARAMS.SERVICE_IDS] = null;

  /**
   * @type {String} Classification IDs to fill by default
   */
  [POSTING_CREATE__QUERY_PARAMS.CLASSIFICATION_IDS] = null;

  /**
   * @type {String} Location ID to fill by default
   */
  [POSTING_CREATE__QUERY_PARAMS.LOCATION_ID] = null;

  /**
   * @type {String} Max rate to fill by default
   */
  [POSTING_CREATE__QUERY_PARAMS.MAX_RATE] = null;

  /**
   * @type {String} Rate type to fill by default
   */
  [POSTING_CREATE__QUERY_PARAMS.RATE_TYPE] = null;
}
